import React, {useState} from 'react';
import FormContainer from '../Components/Form/FormContainer';
import Error from '../Components/Alerts/Error'
import {useForm} from 'react-hook-form'
import Input from '../Components/Form/Input'
import { auth,sendPasswordResetEmail } from '../Firebase/config';
import {Link} from "react-router-dom"


export default function ResetPassword() {
    const {register,formState, handleSubmit} = useForm();
    const {errors} = formState;

    const [error, setError] = useState();

    const resetPassword = (data) => {
        // console.log(email)
        sendPasswordResetEmail(auth, data.email)
        .then((response) => {
            // console.log(response)
        })
        .catch((error) => {
            setError(error.message);
        })
    }
  return (
    <FormContainer>
      {errors.email?.message && <Error message={errors.email.message} />}
      {error && <Error message={error} />}
      <div className="w-full rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 bg-gray-800 border-gray-700">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-xl font-bold leading-tight tracking-tight  md:text-2xl text-white">
          Reset password
          </h1>
          <form
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(resetPassword)}
          >
            <Input
              label="Enter Email"
              type="email"
              placeholder="name@company.com"
              {...register("email", {
                required: "Enter Your Email",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter Valid Email",
                },
              })}
            />
            
            <button
              type="submit"
              className="w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-blue-600 hover:bg-bule-700 focus:ring-blue-800"
            >
              Send E-mail
            </button>
            <p className="text-sm font-light  text-gray-400">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="font-medium hover:underline text-blue-500"
                >
                  login here
                </Link>
                </p>
          </form>
        </div>
      </div>
    </FormContainer>
  );
}
